import { render, staticRenderFns } from "./AddOrgUserModal.vue?vue&type=template&id=6db25820&"
import script from "./AddOrgUserModal.vue?vue&type=script&lang=ts&"
export * from "./AddOrgUserModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6db25820')) {
      api.createRecord('6db25820', component.options)
    } else {
      api.reload('6db25820', component.options)
    }
    module.hot.accept("./AddOrgUserModal.vue?vue&type=template&id=6db25820&", function () {
      api.rerender('6db25820', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizations/AddOrgUserModal.vue"
export default component.exports